import { Center, Flex } from '@chakra-ui/react';

import Description from '../../../components/Description';
import Title from '../../../components/Title';
import { Button } from '../../../components/ui/buttons/Button';
import { COUNTRY_CONFIG } from '../../../constants/countries';
import { Country } from '../../../gql/generated/graphql';

type ProvinceDeadEndProps = {
  provinceName: string;
  onChangeProvince: () => void;
  country: Country;
};

const ProvinceDeadEnd = ({ provinceName, onChangeProvince, country }: ProvinceDeadEndProps) => {
  const { regions, supportedRegions } = COUNTRY_CONFIG[country];

  const supportedRegionNames = new Intl.ListFormat('en', { type: 'conjunction' }).format(
    regions
      .filter((region) => supportedRegions?.includes(region.value))
      .map((region) => region.name),
  );

  return (
    <Flex direction="column" alignItems="center" gap={4} textAlign="center" py={4}>
      <Title as="h2" fontSize="24px">
        We're not in {provinceName} yet
      </Title>
      <Description>
        Right now we can only help drivers who live in {supportedRegionNames}. More of Canada is
        coming soon.
      </Description>
      <Center>
        <Button variant="link" onClick={onChangeProvince}>
          Change province
        </Button>
      </Center>
    </Flex>
  );
};

export default ProvinceDeadEnd;
